export default [
    {
        component: () => import(/* webpackChunkName: 'cadastro-oci' */ '@/views/cadastro/oci/Index'),
        path: 'oci',
        redirect: 'oci/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'cadastro-oci' */ '@/views/cadastro/oci/List.vue'),
                name: 'cadastro-oci-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-oci' */ '@/views/cadastro/oci/Form.vue'),
                name: 'cadastro-oci-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-oci' */ '@/views/cadastro/oci/Form.vue'),
                name: 'cadastro-oci-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]